export default __webpack_public_path__ + "static/media/video.c6462e0e.png";